const API_URL = "https://dev.ypodo.com/api/"
const API_TOKEN = "iNVxQizNqBZPMmfrmelVdXIAv8M0MTeJyjQi1kB8NXLY8pfV4Uy2I7M9CtTq"
const API_ID = "1"
export default {
  API_URL: API_URL,
  API_TOKEN: API_TOKEN,
  API_ID: API_ID
}